import { TYPES as MODAL_TYPES } from 'actions/modalActions';

export default function modalReducer(state = '', action) {
  switch (action.type) {
    case MODAL_TYPES.TOGGLE_MODAL:
      return {
        name: action.modal,
        config: action.config,
      };
    case MODAL_TYPES.SET_MODAL_CLOSING:
      return Object.assign({}, state, {
        config: Object.assign({}, state.config, {
          isClosing: true,
        }),
      });
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/modalReducer.js
 **/